import React, { useState, useEffect, useRef } from "react";
import {
    Container, Row, Col,
    Card, CardBody, Button
} from 'reactstrap';
import axios from 'axios';
import uuid from 'react-uuid';
import SpinnerContainer from './Utilities/Ui/SpinnerContainer'; import { apiGet, apiPost } from "./Utilities/Hooks/apiWrapper";

const UserGuides = () => {
    const [sectionList, setSectionList] = useState([]); const [loading, setLoading] = useState(true);
    const populateList = async () => {
        try {
            const response = await apiGet(
                '/api/settings/GetUserGuides/', {
                params: {}
            }
            );
            setSectionList(response.data);
            setLoading(false)
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }
    useEffect(() => {
        populateList();
    }, []);
    return (
        <div>
            <Container fluid className="p-4 bg-light">
                {/* Header Bar */}
                <Row className="justify-content-center">
                    <Col lg="9" md="10">
                        <div className="text-white px-3 py-2 fw-bold mb-3" style={{ backgroundColor: '#B6D137' }}>
                            User Guide
                        </div>
                    </Col>
                </Row>
                {
                    loading ? <SpinnerContainer /> :
                        <Row className="justify-content-center">
                            <Col lg="9" md="10">
                                <Row>
                                    <Col md="9">
                                        {sectionList && sectionList.length > 0 && sectionList.map(section => (
                                            <Card key={uuid()} className="mb-4 border-top border-5 border-success">
                                                <CardBody>
                                                    <div
                                                        className="text-white fw-bold px-3 py-2 mb-3 rounded-top"
                                                        style={{ backgroundColor: "#008436" }}
                                                    >
                                                        {section.section}
                                                    </div>
                                                    {section.userGuides && section.userGuides.length > 0 && section.userGuides.map((userGuide, index) => (
                                                        <React.Fragment key={uuid()}>
                                                            <Row className="mb-3">
                                                                <Col md="3" className="d-flex align-items-start">
                                                                    <a
                                                                        href={`/UserGuidePDFs/${userGuide.physicalFilename}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <img
                                                                            src={`/UserGuideThumbnails/${userGuide.thumbnailname}`}
                                                                            alt="Login"
                                                                            className="border"
                                                                            style={{ width: '150px', height: '150px', objectFit: 'contain' }}
                                                                        />
                                                                    </a>

                                                                </Col>
                                                                <Col md="9">
                                                                    <ul className="ps-3">
                                                                        {userGuide.descriptionList && userGuide.descriptionList.length > 0 &&
                                                                            userGuide.descriptionList.map(description => (
                                                                                <li key={uuid()}>{description.description}</li>
                                                                            ))}
                                                                        <p className="fw-bold text-primary" style={{ cursor: 'pointer' }}>
                                                                            <a
                                                                                href={`/UserGuidePDFs/${userGuide.physicalFilename}`}
                                                                                target="_blank" rel="noopener noreferrer"
                                                                                className="fw-bold text-primary"
                                                                                style={{ cursor: 'pointer', textDecoration: 'none' }}
                                                                            >
                                                                                Click to open
                                                                            </a>
                                                                        </p>
                                                                    </ul>
                                                                </Col>
                                                            </Row>

                                                            {/* Show separator only if not the last item */}
                                                            {index < section.userGuides.length - 1 && <hr className="my-3" />}
                                                        </React.Fragment>
                                                    ))}

                                                </CardBody>
                                            </Card>
                                        ))}
                                    </Col>
                                    <Col md="3">
                                        <Row>
                                            <Col>
                                                <Card className="border-0 shadow-sm">
                                                    <CardBody className="text-center bg-white1">

                                                        <p className="fw-bold text-success">Download the complete User Guide</p>
                                                        <img
                                                            src="/UserGuideThumbnails/0 Complete Manual.jpg"
                                                            alt="User Guide"
                                                            className="border mb-3"
                                                            style={{
                                                                width: '100%', maxWidth: '180px', height: '100%', maxHeight: '180px',
                                                                objectFit: 'contain'
                                                            }}
                                                        />&nbsp;&nbsp;
                                                        <a
                                                            href="/UserGuidePDFs/ZESPRI FWRMP Tool - USER GUIDANCE - GET VERSION.pdf"
                                                            target="_blank" rel="noopener noreferrer"
                                                            style={{ textDecoration: 'none' }}
                                                        >
                                                            <Button style={{ backgroundColor: "#008436" }}>Download</Button>
                                                        </a>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <br/>
                                        <Row className="justify-content-center">
                                            <Col md="12" className="text-center">
                                                <h5 style={{ color: "#008436" }}>ZESPRI Environmental Team</h5>
                                                <p style={{ margin: 0 }}>Christina Robinson</p>
                                                <p style={{ fontSize: "13px", margin: 0 }}>M: +64 (0)27 203 9913</p>
                                                <p style={{ fontSize: "13px", margin: 0 }}>
                                                    E: <a href="mailto:christina.robinson@zespri.com">christina.robinson@zespri.com</a>
                                                </p>
                                                <br/>
                                                <p style={{ margin: 0 }}>Jayson Benge</p>
                                                <p style={{ fontSize: "13px", margin: 0 }}>M: +64 (0)27 203 9913</p>
                                                <p style={{ fontSize: "13px", margin: 0 }}>
                                                    E: <a href="mailto:jayson.benge@zespri.com">jayson.benge@zespri.com</a>
                                                </p>
                                                <br />
                                                <p style={{ margin: 0 }}>Jolene Francis</p>
                                                <p style={{ fontSize: "13px", margin: 0 }}>M: +64 (0)27 203 9913</p>
                                                <p style={{ fontSize: "13px", margin: 0 }}>
                                                    E: <a href="mailto:jolene.francis@zespri.com">jolene.francis@zespri.com</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                }
            </Container>
        </div>
        
    );
};

export default UserGuides;
